import { useEffect, useState } from "react";
import { menuService } from "../../services/menu/menuService";
import { getTenant } from "../../utils/tenantManager";
import toast from "react-hot-toast";

// 🔥 GLOBAL CACHE (per tenant)
let cachedMenus: any[] = [];
let cachedTenantId: string | null = null;
let isLoaded = false;

export const clearMenuCache = () => {
  cachedMenus = [];
  cachedTenantId = null;
  isLoaded = false;
};

export const useMenuViewModel = () => {
  const tenantId = getTenant();

  const [menus, setMenus] = useState<any[]>(cachedMenus);
  const [loading, setLoading] = useState(false);

  const loadMenus = async () => {
    if (!tenantId) return;

    setLoading(true);
    try {
      const res = await menuService.getByCompany(tenantId);

      cachedMenus = res || [];
      cachedTenantId = tenantId;
      isLoaded = true;

      setMenus(cachedMenus);
    } catch (err: any) {
      toast.error("Failed to load menus");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!tenantId) return;

    // 🔥 reuse cache if same tenant already loaded
    if (isLoaded && cachedTenantId === tenantId) {
      setMenus(cachedMenus);
      return;
    }

    loadMenus();
  }, [tenantId]);

  return {
    menus,
    loading,
    reloadMenus: loadMenus,
  };
};